import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { client } from '../../../utils'
import { routePaths } from '../../urls'
import { useStateValue } from '@State'
import { StatusMarker } from '../StatusMarker'

export const BrightspaceTest = () => {
  const [state] = useStateValue()
  const [testing, setTesting] = useState(false)
  const [passed, setPassed] = useState(false)
  const [error, setError] = useState(false)

  const runTest = async () => {
    setTesting(true)
    setPassed(false)
    setError(false)
    let url = `/links/client_brightspace.test/${state.coursenum}/`
    try {
      var resp = await client.get(url)
    } catch (e) {
      console.error(`Error requesting ${url}`, e)
      setTesting(false)
      setError(true)
      return
    }
    let success = resp.data.success
    setTesting(false)
    setPassed(success)
    setError(!success)
  }

  let buttonText = testing ? 'Testing...' : 'Test Integration'
  let alert = error ? (
    <div className="alert alert-danger">Test Failed</div>
  ) : passed ? (
    <div className="alert alert-success">
      Test passed! Everything is working as expected.
    </div>
  ) : null
  let testIcon = error
    ? 'icon_warning'
    : passed
    ? 'icon_checkmark'
    : 'icon_notification'

  return (
    <div>
      <div className="canvas-flex-wrapper">
        <div className="canvas-form-container">
          <h2>Test Brightspace Integration</h2>
          {alert}
          <p>
            Use this tool to test the Brightspace integration. If there are
            any issues, you may need to go back to the previous step and
            re-authenticate your account.
          </p>
          <p>
            If you&apos;re experiencing issues with the Brightspace
            integration, please contact our support team at &nbsp;
            <a href="mailto:support@myeducator.com">support@myeducator.com</a>
            .
          </p>
          <Link
            to={routePaths.brightspaceAssessments}
            className="btn btn-myed btn-default btn-default-myed"
          >
            Back
          </Link>
          <button
            className="btn btn-myed btn-primary btn-primary-myed"
            disabled={testing}
            onClick={runTest}
          >
            {buttonText}
          </button>
        </div>
        <div className="canvas-statusmarker-container">
          <StatusMarker iconType={testIcon} />
        </div>
      </div>
    </div>
  )
}

